import React from 'react'

import RouteIcon from 'components/configured-service/Schedule/RouteIcon'
import SharedMapMarker from 'components/configured-service/Schedule/SharedMapMarker'
import { COMMON } from 'theme/colors'

// Matches the WebGL layer's default, so the render path can't change a pin's size.
const ICON_SIZE = 30

// Position, id and handlers ride straight through to `SharedMapMarker`, so they're borrowed rather than restated.
type RouteMarkerProps = React.ComponentProps<typeof SharedMapMarker> & {
  routes?: Array<{ routeId?: string; color?: string }> | null
  selectedRoutesMap?: Record<string, boolean>
  isActive?: boolean
  isDimmed?: boolean
  iconSize?: number
}

const RouteMarker = ({ routes, selectedRoutesMap, isActive, isDimmed = false, iconSize = ICON_SIZE, ...others }: RouteMarkerProps) => {
  // An unassigned stop arrives as an explicit null, which a default parameter wouldn't catch.
  const assignedRoutes = routes ?? []
  const visibleRoutes = selectedRoutesMap
    ? assignedRoutes.filter(route => route.routeId && selectedRoutesMap[route.routeId] !== false)
    : assignedRoutes
  return (
    <SharedMapMarker isDimmed={isDimmed} zIndex={isActive ? 1000 : 10} {...others}>
      <RouteIcon borderColor={COMMON.white} borderWidth={1.5} routes={visibleRoutes} size={iconSize} />
    </SharedMapMarker>
  )
}

export default React.memo(RouteMarker)
